import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getApiBaseUrl, getAuthToken } from '../../../services/api';

const API_BASE = () => `${getApiBaseUrl()}/api/admin/resources`;

const PageContentTab = () => {
  const { t } = useTranslation('resourcesManagement');
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [result, setResult] = useState('');

  useEffect(() => {
    const token = getAuthToken();
    const headers = { Accept: 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;
    fetch(`${API_BASE()}/page-content`, { headers })
      .then((r) => r.json())
      .then((data) => data.success && setContent(data.content || {}))
      .finally(() => setLoading(false));
  }, []);

  const handleSave = () => {
    setSaving(true);
    setResult('');
    const token = getAuthToken();
    if (!token) return setResult('Not authenticated');
    fetch(`${API_BASE()}/page-content`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ content }),
    })
      .then((r) => r.json())
      .then((data) => setResult(data.success ? 'Saved.' : (data.message || 'Failed')))
      .catch((e) => setResult(e.message))
      .finally(() => setSaving(false));
  };

  const update = (key, value) => setContent((c) => ({ ...c, [key]: value }));

  if (loading) return <div className="tab-content"><div className="loading-message">Loading page content...</div></div>;
  return (
    <div className="tab-content">
      <p>Edit the public Resources (Exams Bank) page title, subtitle, and labels. Stored in database; public page can read via API or i18n fallback.</p>
      <div className="resources-form-card">
        <div className="resources-form-group">
          <label>{t('pageContent.pageTitle')}</label>
          <input type="text" value={content.resources_title || ''} onChange={(e) => update('resources_title', e.target.value)} placeholder="Exams Bank" />
        </div>
        <div className="resources-form-group">
          <label>{t('pageContent.subtitle')}</label>
          <textarea value={content.resources_subtitle || ''} onChange={(e) => update('resources_subtitle', e.target.value)} rows={3} placeholder="Access exams for all Algerian educational levels. PDFs are free, Word requires login." />
        </div>
        <div className="resources-form-actions">
          <button type="button" className="action-btn" onClick={handleSave} disabled={saving}>{t('pageContent.save')}</button>
          {result && <span className="resources-form-result">{result}</span>}
        </div>
      </div>
    </div>
  );
};

export default PageContentTab;
